import { MICRO_PER_CREDIT } from '../../composables/useCreditWallet'

/**
 * Humanize a micro-credit amount as credits for display
 * (e.g. 5_000_000 → '5'; 200_100_000 → '200,1').
 *
 * The wallet's balance_display is the backend's RAW 6-decimal string
 * (number_format(micro/1e6, 6, '.', '') — e.g. '200.100022') and must never
 * be shown to users. Components render `${formatCredits(micro)} ${t('cr')}`.
 */
export function formatCredits(micro: number | string | null | undefined): string {
  const num = typeof micro === 'string' ? parseFloat(micro) : Number(micro || 0)
  if (isNaN(num) || num === 0) return '0'
  return (num / MICRO_PER_CREDIT).toLocaleString('pt-BR', { maximumFractionDigits: 2 })
}

